import React from "react";

export default function DownArrow(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="16"
      height="8"
      viewBox="0 0 16 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 4.76277L1.78571 0L0.5 1.75182L8 7.5L15.5 1.75182L14.2143 5.22084e-08L8 4.76277Z"
      />
    </svg>
  );
}
